<template>
  <div class="text-textColor">
    <!-- forgot password -->
    <transition name="fade">
      <div
        v-if="showForgotPassword"
        class="bg-black fixed bg-opacity-80 inset-0 z-50 h-screen w-full"
      >
        <div
          class="fixed center-h-v bg-white rounded-md sm:w-1/3 w-full shadow-2xl"
        >
          <div v-if="loading" class="absolute inset-0 bg-black bg-opacity-80">
            <loader class="absolute center-h-v" />
          </div>
          <div
            class="flex justify-between items-center text-sm border-b-1.5 p-3"
          >
            <p>Forgot Password</p>
            <img
              v-if="!loading"
              class="h-5 object-contain bg-primary rounded-md cursor-pointer hover:shadow-lg"
              src="@/assets/icons/cross-white.png"
              @click="showForgotPassword = false"
            />
          </div>
          <form class="m-3" @submit.prevent="resetPassword">
            <div class="flex flex-col items-center justify-center">
              <p class="text-center font-medium text-sm text-textColor p-5">
                Provide your account's username for which you want to reset your
                password!
              </p>
              <input
                type="text"
                required
                v-model="resetPasswordEmail"
                placeholder="Username"
                class="border-0.5 text-xs border-inputBorder p-3 rounded w-3/4 mb-6"
              />
            </div>
            <div class="flex justify-center">
              <button
                class="bg-primary text-white p-2 rounded w-3/4 mb-6 hover:bg-primaryHover focus:outline-none"
              >
                Reset password
              </button>
            </div>
          </form>
        </div>
      </div>
    </transition>

    <!-- loader -->
    <transition name="fade">
      <div
        v-if="loading"
        class="inset-0 absolute toppest bg-black bg-opacity-80 h-screen w-full"
      >
        <loader class="center-h-v" />
      </div>
    </transition>

    <div v-if="!loading">
      <div class="h-screen grid grid-cols-1 lg:grid-cols-2 w-full relative">
        <features class="hidden lg:block"></features>
        <div>
          <div class="flex justify-center h-full flex-col sm:ml-20">
            <div class="text-textColorGray">
              <div
                v-if="organization"
                class="flex items-center gap-5 divide-x-0.5 sm:px-0 px-10 divide-textColorGray"
              >
                <img
                  class="h-10 sm:h-14 object-contain"
                  :src="organization.logo"
                />
                <p class="px-3 sm:text-lg text-sm font-semibold">
                  {{ organization.name }}
                </p>
              </div>
              <div class="py-5 sm:py-10 sm:px-0 px-10">
                <h1 class="text-4xl pb-5 font-bold">Welcome back</h1>
                <h1 class="text-sm">Please login to your account</h1>
              </div>

              <!-- login form -->
              <form
                class="w-full sm:px-0 px-10 flex flex-col"
                @submit.prevent="login"
              >
                <transition name="fade">
                  <div
                    v-if="resetPasswordEmailSent"
                    class="text-xs border-1.5 border-primary mb-6 flex items-center p-2 gap-4 sm:w-4/6"
                  >
                    <img class="h-5" src="@/assets/icons/check.png" />
                    <p class="font-bold">
                      We have sent you an email. Follow the instructions
                      outlined on the email on how to reset your password.
                    </p>
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    v-if="error"
                    class="text-xs border-1.5 border-red-400 mb-6 flex items-center p-2 gap-4 sm:w-4/6"
                  >
                    <img class="h-5" src="@/assets/icons/cross.png" />
                    <p class="font-bold">{{ error }}</p>
                  </div>
                </transition>
                <input
                  v-model="info.UserName"
                  placeholder="Username"
                  type="text"
                  required
                  class="text-xs font-semibold rounded-md border-1.5 p-3 focus:outline-none sm:w-4/6 mb-6"
                />
                <div
                  class="flex sm:w-4/6 items-center gap-5 border-1.5 pr-3 rounded-md mb-2"
                >
                  <input
                    v-model="info.Password"
                    required
                    :type="type"
                    placeholder="Password"
                    class="text-xs font-semibold w-full py-3 focus:outline-none"
                  />
                  <img
                    @click="showPassword"
                    class="h-3 cursor-pointer"
                    :src="
                      type === 'password' ? hidePasswordIcon : showPasswordIcon
                    "
                  />
                </div>
                <div class="text-xs py-6 pl-1 flex">
                  <!-- <input type="checkbox" /> Remember me -->
                  <p
                    @click="showForgotPassword = true"
                    class="underline cursor-pointer hover:text-buttonColor"
                  >
                    Forgot Password?
                  </p>
                </div>
                <button
                  type="submit"
                  class="bg-primary hover:bg-primary text-white sm:w-4/6 p-2 sm:p-3 mt-0 sm:mt-6 rounded-md font-semibold text-sm"
                >
                  LOGIN
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PasswordRestDialog
      :open="isDialogOpen"
      :callback="handleDialog"
    ></PasswordRestDialog>
  </div>
</template>
<script>
import features from '@/components/carousel/features.vue';
import axios from 'axios';
import Loader from '../components/loader/loader.vue';
import config from '@/config/config';
import { mapGetters } from 'vuex';
// import { viewSecuredAttachment } from "@/utils/secureAttachmentsViewer";
import PasswordRestDialog from './passwordRestConfirmation.vue';

export default {
  name: 'Login',
  components: {
    features,
    Loader,
    PasswordRestDialog,
  },
  data() {
    return {
      hostname: '',
      organization: {
        logo: '',
        name: '',
      },
      isDialogOpen: false,
      userConfirmed: false,
      currentUrl: '',
      type: 'password',
      showPasswordIcon: require('@/assets/icons/eye.png'),
      hidePasswordIcon: require('@/assets/icons/eye-crossed.png'),
      info: {
        UserName: this.$route.query.username,
        Password: this.$route.query.password,
      },
      error: null,
      resetPasswordEmail: null,
      resetPasswordEmailSent: false,
      loading: false,
      showForgotPassword: false,
      organizationName: null,
      role: '',
    };
  },
  computed: {
    ...mapGetters(['getUserType']),
  },
  created() {
    if (this.info.UserName && this.info.Password) {
      this.login();
    }
    // this.getOrganizationName();
  },
  methods: {
    showPassword() {
      this.type = this.type === 'password' ? 'text' : 'password';
    },
    handleDialog(userConfirmed) {
      this.userConfirmed = userConfirmed;
      this.isDialogOpen = false;

      if (userConfirmed) {
        // User confirmed
        this.resetPassword();
      } else {
        // User declined
        this.loading = false;
        this.showForgotPassword = false;
      }
    },

    async resetPassword() {
      this.isDialogOpen = true;
      this.loading = true;

      if (this.userConfirmed) {
        let data = {
          Username: this.resetPasswordEmail,
        };
        const options = {
          headers: {
            'Content-Type': 'application/json',
          },
        };

        try {
          await axios.post(
            `${this.organizationName}/account/password/${this.$ApiVersion}/forgot`,
            JSON.stringify(data),
            options
          );
          this.loading = false;
          this.showForgotPassword = false;
          this.resetPasswordEmailSent = true;
          this.userConfirmed = false;
          setTimeout(() => {
            this.resetPasswordEmailSent = false;
          }, 10000);
        } catch (error) {
          this.loading = false;
          this.userConfirmed = false;
        }
      } else {
        this.loading = false;
        this.showForgotPassword = false;
      }
    },

    async login() {
      // alert(1);
      this.loading = true;
      this.error = null;

      const options = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      try {
        const response = await axios.post(
          `oauth/${this.$ApiVersion}/generate`,
          JSON.stringify(this.info),
          options
        );

        this.loading = false;

        if (response.data.StatusCode === 200) {
          const { Role, PasswordChanged, OrganizationName } = response.data;
          this.$store.commit('setOrganizationDetails', response.data);

          this.organization = this.$store.getters.getOrganizationDetails;

          this.$store.commit('login', response.data);
          this.organizationName = OrganizationName;
          console.log(response.data);
          this.$store.commit('setRefreshToken', response.data?.RefreshToken);
          if (
            ['administrator', 'systemadministrator'].includes(
              Role?.toLowerCase()
            )
          ) {
            this.error = 'Access denied!';
            setTimeout(() => {
              this.error = null;
            }, 1500);
            return;
          }

          switch (Role) {
            case 'HrManager':
              this.$store.commit('setUserType', 'HR Manager');
              break;
            case 'Manager':
              this.$store.commit('setUserType', 'Manager');
              break;
            case 'Employee':
              this.$store.commit('setUserType', 'Employee');
              break;
            default:
              break;
          }

          const routeName = PasswordChanged ? 'dashboard' : 'changePassword';
          this.$router.replace({
            name: routeName,
            params: { company: `${this.organizationName}` },
          });
        } else {
          this.error = response.data.StatusMessage;
          setTimeout(() => {
            this.error = null;
          }, 1500);
        }
      } catch (error) {
        this.$store.commit('login', error);

        if (error.response) {
          this.error = error.response.data.error_description;
        } else {
          this.error = error.message;
        }

        setTimeout(() => {
          this.error = null;
        }, 1500);

        this.loading = false;
      }
    },

    changePassword() {
      this.$router.replace({
        name: 'changePassword',
        params: { company: this.getOrganization },
      });
    },

    getOrganizationName() {
      // alert(1);
      this.loading = true;

      this.organizationName = this.$route.params.company;
      axios
        .get(
          `${config.baseURL}organization/${this.$route.params.company}/v1/validate`
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.loading = false;
              this.$store.commit('setOrganizationDetails', response.data.Data);

              this.organization = this.$store.getters.getOrganizationDetails;
            } else {
              this.error = response.data.StatusMessage;
            }
            if (response.data.StatusCode === 404) {
              this.$router.replace({
                name: 'OrgNotFound',
                params: { company: this.getOrganization },
              });
            }
          },
          (error) => {
            this.$store.commit('setOrganizationDetails', error);
            if (error.response) {
              this.error = error.response.data.error_description;
              setTimeout(() => {
                this.error = null;
              }, 1500);
            } else {
              this.error = error.message;
              setTimeout(() => {
                this.error = null;
              }, 1500);
            }
            this.loading = false;
          }
        );
    },
  },
};
</script>
<style scoped>
.toppest {
  z-index: 9999999;
}
</style>
